interface SeasonPickerProps {
  seasons: number[];
  value: number;
  onChange: (season: number) => void;
}

export function SeasonPicker({ seasons, value, onChange }: SeasonPickerProps) {
  return (
    <label className="season-picker">
      <span className="season-picker__label">Season</span>
      <select
        className="season-picker__select"
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
      >
        {[...seasons]
          .sort((a, b) => b - a)
          .map((season) => (
            <option key={season} value={season}>
              {season}
            </option>
          ))}
      </select>
    </label>
  );
}
